export default "__VITE_ASSET__CRlYAXQE__"